import {axiosUtil} from "../../../utils/axios_util";

const videoListApi = {
    //分页查询视频
    getVideoPage(data:powerSearchData) {
        return axiosUtil({
            url: '/videos/manager/findByPage',
            method: 'post',
            data,
            params: {
                page: data.page,
                size: data.size
            }
        })
    },
    //获取临时上传地址
    getUploadVideoUrl(data:any) {
        return axiosUtil({
            url: `/videos/manager/pre-signed-put`,
            method: 'post',
            data
        })
    },
    //获取临时上传地址-大数据
    getNewUploadVideoUrl(data:any) {
        return axiosUtil({
            url: `/videos/manager/createUploadUrl`,
            method: 'post',
            data
        })
    },
    //上传视频
    videoUpload(data: any,videoTag:string) {
        return axiosUtil({
            url: `/videos/manager/upload?videoTag=${videoTag ? videoTag : '' }`,
            method: 'post',
            data
        })
    },
    //获取video临时下载地址
    getVideoUrl(videoNo: string) {
        return axiosUtil({
            url: `/videos/manager/video/getPreSignedUrl/${videoNo}`,
            method: 'post',
        })
    },
    //删除视频
    deleteVideo(videoNo: string) {
        return axiosUtil({
            url: `/videos/manager/deleteVideo/${videoNo}`,
            method: 'post',
        })
    },
    //更新视频标签
    updateVideoTag(videoNo: string,data: any) {
        return axiosUtil({
            url: `/videos/manager/updateTag/${videoNo}`,
            method: 'post',
            data
        })
    },
    //视频操作 1-上架 2-下架
    videoOperate(data:any) {
        return axiosUtil({
            url: `/videos/manager/videoOperate/${data.videoNo}/${data.operate}`,
            method: 'post',
            data,
        })
    },


    //查询挂机短信
    findCallOffMessage() {
        return axiosUtil({
            url: `/videos/manager/findCallOffMessage`,
            method: 'post',
        })
    },
    //更新挂机短信
    updateCallOffMessage(cutOffMessage:string) {
        return axiosUtil({
            url: `/videos/manager/updateCallOffMessage?cutOffMessage=${cutOffMessage}`,
            method: 'post',
        })
    },
    //查询视频详情
    findVideoInfo(videoNo: string) {
        return axiosUtil({
            url: `/videos/manager/findVideoInfo/${videoNo}`,
            method: 'post',
        })
    },
    //更新失败短信
    updateFailMessage(videoNo: string,data: any) {
        return axiosUtil({
            url: `/videos/manager/updateFailMessage/${videoNo}`,
            method: 'post',
            data
        })
    },
}

export default videoListApi
